import {
    CmsEditableFields,
    CmsFlexibleBackgroundFields,
} from '@activebrands/core-web/libs/storyblok/content/cms-module-content';
import { RawSplitData } from '@activebrands/core-web/libs/storyblok/storyblok';
import extractBackgroundOverlays from '@activebrands/core-web/libs/storyblok/utils/extract-background-overlays';
import { RawBackgroundData } from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-background';
import transformFlexibleBackgrounds from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-backgrounds';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import ReturnIframe from '@activebrands/core-web/components/content-components/ReturnIframe';

export interface ReturnIframeContent extends CmsEditableFields, CmsFlexibleBackgroundFields {
    iframeSrc?: string;
}

export interface ReturnIframeDataTransformerBlockProps {
    content?: ReturnIframeContent;
}

const ReturnIframeDataTransformerBlock = ({ content = {} }: ReturnIframeDataTransformerBlockProps) => {
    const { _editable, iframeSrc, backgroundDesktop, backgroundMobile } = content;

    const rawBackgrounds = [backgroundMobile?.[0] ?? null, null, null, null, backgroundDesktop?.[0] ?? null];

    const transformedBackgrounds = transformFlexibleBackgrounds(rawBackgrounds);
    const backgroundOverlays = extractBackgroundOverlays(rawBackgrounds as (RawBackgroundData | RawSplitData)[]);

    return (
        <ReturnIframe
            src={iframeSrc ?? ''}
            sbEditable={transformPreviewEditable(_editable)}
            backgrounds={transformedBackgrounds}
            backgroundOverlays={backgroundOverlays}
        />
    );
};

export default ReturnIframeDataTransformerBlock;
